// Milieu-spezifische Beschreibungen für die 10 Basissicherheit-Module
// Jedes Modul hat eine Beschreibung für jedes Milieu

export const MODULE_DESCRIPTIONS = {
    "Sichere Passwörter": {
      "Traditionell": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Bewährte Regeln, die immer gelten und Ihnen Sicherheit geben.",
      "Konservativ‑Gehoben": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Schützen Sie Ihre Reputation und Handlungsfähigkeit mit bewährten Sicherheitsstandards.",
      "Performer": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Effiziente Grundlage für maximale Sicherheit ohne Zeitverlust.",
      "Expeditiv": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Moderne Sicherheitsstandards, die mit innovativen Methoden funktionieren.",
      "Adaptiv‑Pragmatische Mitte": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Praktische Regeln, die einfach umzusetzen sind und zuverlässig schützen.",
      "Neo‑Ökologisch": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Nachhaltige Sicherheitsgrundlage, die langfristig schützt.",
      "Postmateriell": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Fundierte Sicherheitspraxis basierend auf bewährten Standards.",
      "Nostalgisch‑Bürgerlich": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Bewährte Methoden, die einfach und überschaubar sind.",
      "Prekär": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Einfache, kostenlose Regeln für mehr Sicherheit im Alltag.",
      "Konsum‑Hedonistisch": "Erstellen Sie Passwörter mit mindestens 16 Zeichen, die Groß- und Kleinbuchstaben, Zahlen und Sonderzeichen enthalten. Schnell umsetzbar und sofort wirksam."
    },
    "MFA": {
      "Traditionell": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Schritt-für-Schritt Anleitung für verlässliche Sicherheit.",
      "Konservativ‑Gehoben": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Seriöse Sicherheitsmaßnahme zum Schutz Ihrer Daten und Reputation.",
      "Performer": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Zeitsparende Automatisierung für maximale Sicherheit.",
      "Expeditiv": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Moderne Sicherheitstechnologie, die einfach funktioniert.",
      "Adaptiv‑Pragmatische Mitte": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Nachhaltige Sicherheitsmaßnahme für langfristigen Schutz.",
      "Postmateriell": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Fundierte Sicherheitspraxis basierend auf bewährten Standards.",
      "Nostalgisch‑Bürgerlich": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Kostenlose Sicherheitsmaßnahme, die schnell eingerichtet ist.",
      "Konsum‑Hedonistisch": "Aktivieren Sie 2FA/MFA für alle wichtigen Konten (E-Mail, Banking, Social Media) mit einer Authenticator-App wie Authy oder Google Authenticator. Schnell eingerichtet und sofort wirksam."
    },
    "Passwort-Manager": {
      "Traditionell": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Praktische Einrichtung für verlässliche Routinen.",
      "Konservativ‑Gehoben": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Seriöse Lösung zum Schutz Ihrer Daten und Reputation.",
      "Performer": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Schnelle Integration in Ihren Workflow für maximale Effizienz.",
      "Expeditiv": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Moderne Tools, die innovativ und benutzerfreundlich sind.",
      "Adaptiv‑Pragmatische Mitte": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Praktische Lösung mit klarem Nutzen und guter Bewertung.",
      "Neo‑Ökologisch": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Nachhaltiger und verantwortungsvoller Umgang mit Passwörtern.",
      "Postmateriell": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Fundierte Sicherheitspraxis mit tiefem Verständnis der Mechanismen.",
      "Nostalgisch‑Bürgerlich": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Bewährte Methode, einfach und überschaubar.",
      "Prekär": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Kostenlose Lösung, die einfach zu nutzen ist.",
      "Konsum‑Hedonistisch": "Nutzen Sie einen Passwort-Manager wie Bitwarden, 1Password oder KeePass, um sichere, einzigartige Passwörter für alle Ihre Konten zu erstellen und zu speichern. Moderne, benutzerfreundliche Tools, die Spaß machen."
    },
    "Backups": {
      "Traditionell": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Bewährte Methode für verlässliche Datensicherung.",
      "Konservativ‑Gehoben": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Seriöse Sicherheitsmaßnahme zum Schutz Ihrer wichtigen Daten.",
      "Performer": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Automatisierte Lösung für effiziente Datensicherung.",
      "Expeditiv": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Moderne Backup-Lösungen, die automatisch funktionieren.",
      "Adaptiv‑Pragmatische Mitte": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Nachhaltige Datensicherung für langfristigen Schutz.",
      "Postmateriell": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Fundierte Sicherheitspraxis für verantwortungsvolle Datensicherung.",
      "Nostalgisch‑Bürgerlich": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Kostenlose Lösung für mehr Sicherheit im Alltag.",
      "Konsum‑Hedonistisch": "Erstellen Sie regelmäßige Backups Ihrer wichtigen Daten auf externe Festplatten oder Cloud-Speicher. Schnell eingerichtet und automatisch aktiv."
    },
    "Automatische Updates": {
      "Traditionell": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Bewährte Methode für kontinuierliche Sicherheit.",
      "Konservativ‑Gehoben": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Seriöse Sicherheitsmaßnahme zum Schutz Ihrer Systeme.",
      "Performer": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Automatisierte Lösung für maximale Effizienz.",
      "Expeditiv": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Moderne Technologie, die automatisch funktioniert.",
      "Adaptiv‑Pragmatische Mitte": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Praktische Lösung, die im Hintergrund läuft.",
      "Neo‑Ökologisch": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Nachhaltige Sicherheitsmaßnahme für langfristigen Schutz.",
      "Postmateriell": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Fundierte Sicherheitspraxis basierend auf bewährten Standards.",
      "Nostalgisch‑Bürgerlich": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Bewährte Methode, einfach einzurichten.",
      "Prekär": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Kostenlose Sicherheitsmaßnahme, die automatisch funktioniert.",
      "Konsum‑Hedonistisch": "Aktivieren Sie automatische Updates für Ihr Betriebssystem und alle Apps, um Sicherheitslücken zu schließen. Schnell aktiviert und automatisch aktiv."
    },
    "Email Account absichern": {
      "Traditionell": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Schritt-für-Schritt Anleitung für verlässliche Sicherheit.",
      "Konservativ‑Gehoben": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Seriöse Sicherheitsmaßnahme zum Schutz Ihrer wichtigsten Daten.",
      "Performer": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Effiziente Lösung für maximale Sicherheit.",
      "Expeditiv": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Moderne Sicherheitstechnologie, die einfach funktioniert.",
      "Adaptiv‑Pragmatische Mitte": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Nachhaltige Sicherheitsmaßnahme für langfristigen Schutz.",
      "Postmateriell": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Fundierte Sicherheitspraxis basierend auf bewährten Standards.",
      "Nostalgisch‑Bürgerlich": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Kostenlose Sicherheitsmaßnahme, die schnell eingerichtet ist.",
      "Konsum‑Hedonistisch": "Aktivieren Sie 2FA für Ihr E-Mail-Konto, da es der Schlüssel zu allen anderen Konten ist. Verwenden Sie ein starkes, einzigartiges Passwort. Schnell eingerichtet und sofort wirksam."
    },
    "Ad-Blocker": {
      "Traditionell": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Bewährte Methode für mehr Privatsphäre.",
      "Konservativ‑Gehoben": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Seriöse Lösung zum Schutz Ihrer Privatsphäre.",
      "Performer": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Effiziente Lösung für mehr Privatsphäre und bessere Performance.",
      "Expeditiv": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Moderne Tools, die innovativ und benutzerfreundlich sind.",
      "Adaptiv‑Pragmatische Mitte": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Nachhaltige Maßnahme für mehr Privatsphäre und Datenschutz.",
      "Postmateriell": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Fundierte Sicherheitspraxis für verantwortungsvollen Umgang mit Daten.",
      "Nostalgisch‑Bürgerlich": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Kostenlose Lösung für mehr Privatsphäre im Alltag.",
      "Konsum‑Hedonistisch": "Installieren Sie einen Ad-Blocker wie uBlock Origin, um Tracking und schädliche Werbung zu blockieren. Schnell installiert und sofort wirksam."
    },
    "Router Passwort ändern": {
      "Traditionell": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Bewährte Methode für verlässliche Netzwerksicherheit.",
      "Konservativ‑Gehoben": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Seriöse Sicherheitsmaßnahme zum Schutz Ihres Netzwerks.",
      "Performer": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Effiziente Lösung für maximale Netzwerksicherheit.",
      "Expeditiv": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Moderne Sicherheitstechnologie für Ihr Netzwerk.",
      "Adaptiv‑Pragmatische Mitte": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Nachhaltige Sicherheitsmaßnahme für langfristigen Schutz.",
      "Postmateriell": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Fundierte Sicherheitspraxis basierend auf bewährten Standards.",
      "Nostalgisch‑Bürgerlich": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Kostenlose Sicherheitsmaßnahme für mehr Sicherheit im Alltag.",
      "Konsum‑Hedonistisch": "Ändern Sie das Standard-Passwort Ihres Routers und verwenden Sie WPA3-Verschlüsselung, wenn verfügbar. Schnell umgesetzt und sofort wirksam."
    },
    "Social Media": {
      "Traditionell": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Vorsichtige Datenfreigabe für mehr Sicherheit.",
      "Konservativ‑Gehoben": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Seriöse Maßnahme zum Schutz Ihrer Reputation.",
      "Performer": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Effiziente Lösung für maximale Privatsphäre.",
      "Expeditiv": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Moderne Einstellungen für mehr Kontrolle.",
      "Adaptiv‑Pragmatische Mitte": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Nachhaltige Maßnahme für verantwortungsvollen Umgang mit Daten.",
      "Postmateriell": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Fundierte Sicherheitspraxis für mehr Datenschutz.",
      "Nostalgisch‑Bürgerlich": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Kostenlose Maßnahme für mehr Sicherheit im Alltag.",
      "Konsum‑Hedonistisch": "Überprüfen und verschärfen Sie die Privatsphäre-Einstellungen auf allen Social-Media-Plattformen. Teilen Sie so wenig persönliche Informationen wie möglich. Schnell umgesetzt und sofort wirksam."
    },
    "App-Berechtigungen": {
      "Traditionell": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Bewährte Methode für vorsichtige Datenfreigabe.",
      "Konservativ‑Gehoben": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Seriöse Maßnahme zum Schutz Ihrer Privatsphäre.",
      "Performer": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Effiziente Lösung für maximale Kontrolle über Ihre Daten.",
      "Expeditiv": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Moderne Einstellungen für mehr Kontrolle.",
      "Adaptiv‑Pragmatische Mitte": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Praktische Lösung mit klarem Nutzen.",
      "Neo‑Ökologisch": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Nachhaltige Maßnahme für verantwortungsvollen Umgang mit Daten.",
      "Postmateriell": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Fundierte Sicherheitspraxis für mehr Datenschutz.",
      "Nostalgisch‑Bürgerlich": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Bewährte Methode, einfach umzusetzen.",
      "Prekär": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Kostenlose Maßnahme für mehr Sicherheit im Alltag.",
      "Konsum‑Hedonistisch": "Überprüfen Sie regelmäßig die App-Berechtigungen auf Ihrem Smartphone und gewähren Sie nur die notwendigen Berechtigungen. Schnell umgesetzt und sofort wirksam."
    }
  };
  
  // Funktion zum Abrufen der milieuspezifischen Beschreibung
  export const getModuleDescription = (moduleName, milieuName) => {
    if (!moduleName || !milieuName) {
      return null;
    }
    
    const descriptions = MODULE_DESCRIPTIONS[moduleName];
    if (!descriptions) {
      return null;
    }
    
    return descriptions[milieuName] || null;
  };
  
  // Fallback-Beschreibung, wenn keine milieuspezifische Beschreibung gefunden wird
  export const getDefaultDescription = (moduleName) => {
    // Verwende die erste verfügbare Beschreibung als Fallback
    const descriptions = MODULE_DESCRIPTIONS[moduleName];
    if (descriptions) {
      return Object.values(descriptions)[0] || null;
    }
    return null;
  };
  
  // Milieu-spezifische Checklisten für die 10 Basissicherheit-Module
  // Jedes Modul hat eine Checkliste mit Schritten für jedes Milieu
  export const MODULE_CHECKLISTS = {
    "Sichere Passwörter": {
      "Traditionell": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Regelmäßig prüfen und bei Bedarf ändern"
      ],
      "Konservativ‑Gehoben": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Bewährte Standards einhalten"
      ],
      "Performer": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Effizient und systematisch umsetzen"
      ],
      "Expeditiv": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Moderne Methoden nutzen"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Praktisch und einfach umsetzen"
      ],
      "Neo‑Ökologisch": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Nachhaltige Sicherheitspraxis"
      ],
      "Postmateriell": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Fundierte Standards befolgen"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Bewährte Methoden anwenden"
      ],
      "Prekär": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Einfach und kostenlos umsetzen"
      ],
      "Konsum‑Hedonistisch": [
        "Mindestens 16 Zeichen verwenden",
        "Groß- und Kleinbuchstaben kombinieren",
        "Zahlen hinzufügen",
        "Sonderzeichen einbauen",
        "Keine persönlichen Informationen verwenden",
        "Schnell und direkt umsetzen"
      ]
    },
    "MFA": {
      "Traditionell": [
        "Authenticator-App herunterladen (Authy oder Google Authenticator)",
        "App auf dem Smartphone installieren",
        "Für jedes wichtige Konto 2FA aktivieren",
        "Schritt-für-Schritt Anleitung befolgen",
        "Backup-Codes sicher aufbewahren",
        "Regelmäßig prüfen, ob alles funktioniert"
      ],
      "Konservativ‑Gehoben": [
        "Seriöse Authenticator-App wählen (Authy oder Google Authenticator)",
        "App installieren und einrichten",
        "Für alle wichtigen Konten aktivieren",
        "Backup-Codes sicher verwahren",
        "Systematisch alle Konten absichern",
        "Regelmäßig überprüfen"
      ],
      "Performer": [
        "Authenticator-App installieren",
        "Für alle wichtigen Konten aktivieren",
        "Automatisierung nutzen",
        "Backup-Codes sicher speichern",
        "Zeitsparend umsetzen",
        "Effizient verwalten"
      ],
      "Expeditiv": [
        "Moderne Authenticator-App wählen",
        "Schnell einrichten",
        "Für alle wichtigen Konten aktivieren",
        "Backup-Codes sicher aufbewahren",
        "Innovative Methoden nutzen",
        "Experimentieren und optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Authenticator-App installieren",
        "Für wichtige Konten aktivieren",
        "Praktische Lösung nutzen",
        "Backup-Codes aufbewahren",
        "Einfach umsetzen",
        "Bei Bedarf anpassen"
      ],
      "Neo‑Ökologisch": [
        "Authenticator-App installieren",
        "Für alle wichtigen Konten aktivieren",
        "Nachhaltige Sicherheit",
        "Backup-Codes sicher verwahren",
        "Verantwortungsvoll umsetzen",
        "Langfristig schützen"
      ],
      "Postmateriell": [
        "Authenticator-App installieren",
        "Für alle wichtigen Konten aktivieren",
        "Fundierte Sicherheitspraxis",
        "Backup-Codes sicher aufbewahren",
        "Tiefes Verständnis entwickeln",
        "Bewährte Standards befolgen"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Authenticator-App installieren",
        "Für wichtige Konten aktivieren",
        "Bewährte Methode nutzen",
        "Backup-Codes aufbewahren",
        "Einfach umsetzen",
        "Überschaubar halten"
      ],
      "Prekär": [
        "Kostenlose Authenticator-App installieren",
        "Für wichtige Konten aktivieren",
        "Einfache Lösung nutzen",
        "Backup-Codes aufbewahren",
        "Schnell umsetzen",
        "Kostenlos schützen"
      ],
      "Konsum‑Hedonistisch": [
        "Authenticator-App installieren",
        "Für alle wichtigen Konten aktivieren",
        "Schnell einrichten",
        "Backup-Codes aufbewahren",
        "Sofort wirksam",
        "Unterhaltsam umsetzen"
      ]
    },
    "Passwort-Manager": {
      "Traditionell": [
        "Passwort-Manager auswählen (Bitwarden, 1Password oder KeePass)",
        "App installieren und einrichten",
        "Master-Passwort sicher wählen",
        "Alle bestehenden Passwörter importieren",
        "Neue Passwörter automatisch generieren lassen",
        "Regelmäßig prüfen und aktualisieren"
      ],
      "Konservativ‑Gehoben": [
        "Seriösen Passwort-Manager wählen",
        "App installieren und konfigurieren",
        "Starkes Master-Passwort erstellen",
        "Alle Passwörter systematisch importieren",
        "Automatische Generierung nutzen",
        "Professionell verwalten"
      ],
      "Performer": [
        "Passwort-Manager installieren",
        "Schnell einrichten",
        "Master-Passwort wählen",
        "Alle Passwörter importieren",
        "Workflow integrieren",
        "Zeitsparend nutzen"
      ],
      "Expeditiv": [
        "Modernen Passwort-Manager wählen",
        "Innovativ einrichten",
        "Master-Passwort erstellen",
        "Alle Passwörter importieren",
        "Neue Features nutzen",
        "Experimentieren und optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Passwort-Manager installieren",
        "Einfach einrichten",
        "Master-Passwort wählen",
        "Wichtige Passwörter importieren",
        "Praktisch nutzen",
        "Bei Bedarf anpassen"
      ],
      "Neo‑Ökologisch": [
        "Nachhaltigen Passwort-Manager wählen",
        "Verantwortungsvoll einrichten",
        "Master-Passwort erstellen",
        "Alle Passwörter importieren",
        "Langfristig nutzen",
        "Nachhaltig verwalten"
      ],
      "Postmateriell": [
        "Fundierten Passwort-Manager wählen",
        "Tief einrichten",
        "Master-Passwort erstellen",
        "Alle Passwörter importieren",
        "Verständnis entwickeln",
        "Bewährte Praxis anwenden"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Bewährten Passwort-Manager wählen",
        "Einfach einrichten",
        "Master-Passwort wählen",
        "Wichtige Passwörter importieren",
        "Überschaubar nutzen",
        "Klassisch verwalten"
      ],
      "Prekär": [
        "Kostenlosen Passwort-Manager wählen",
        "Einfach einrichten",
        "Master-Passwort wählen",
        "Wichtige Passwörter importieren",
        "Kostenlos nutzen",
        "Praktisch verwalten"
      ],
      "Konsum‑Hedonistisch": [
        "Benutzerfreundlichen Passwort-Manager wählen",
        "Schnell einrichten",
        "Master-Passwort erstellen",
        "Alle Passwörter importieren",
        "Spaß beim Nutzen",
        "Modern verwalten"
      ]
    },
    "Backups": {
      "Traditionell": [
        "Externe Festplatte oder Cloud-Speicher wählen",
        "Backup-Plan erstellen",
        "Regelmäßige Backups einrichten",
        "Wichtige Daten auswählen",
        "Bewährte Methode nutzen",
        "Regelmäßig prüfen"
      ],
      "Konservativ‑Gehoben": [
        "Seriösen Backup-Service wählen",
        "Systematisch einrichten",
        "Regelmäßige Backups planen",
        "Alle wichtigen Daten sichern",
        "Professionell verwalten",
        "Regelmäßig überprüfen"
      ],
      "Performer": [
        "Backup-Lösung wählen",
        "Automatisierung einrichten",
        "Regelmäßige Backups aktivieren",
        "Wichtige Daten sichern",
        "Effizient verwalten",
        "Zeitsparend nutzen"
      ],
      "Expeditiv": [
        "Moderne Backup-Lösung wählen",
        "Innovativ einrichten",
        "Automatische Backups aktivieren",
        "Alle Daten sichern",
        "Neue Features nutzen",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Praktische Backup-Lösung wählen",
        "Einfach einrichten",
        "Regelmäßige Backups aktivieren",
        "Wichtige Daten sichern",
        "Praktisch nutzen",
        "Bei Bedarf anpassen"
      ],
      "Neo‑Ökologisch": [
        "Nachhaltige Backup-Lösung wählen",
        "Verantwortungsvoll einrichten",
        "Regelmäßige Backups aktivieren",
        "Alle wichtigen Daten sichern",
        "Langfristig schützen",
        "Nachhaltig verwalten"
      ],
      "Postmateriell": [
        "Fundierte Backup-Lösung wählen",
        "Tief einrichten",
        "Regelmäßige Backups aktivieren",
        "Alle wichtigen Daten sichern",
        "Verantwortungsvoll verwalten",
        "Bewährte Praxis anwenden"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Bewährte Backup-Lösung wählen",
        "Einfach einrichten",
        "Regelmäßige Backups aktivieren",
        "Wichtige Daten sichern",
        "Überschaubar nutzen",
        "Klassisch verwalten"
      ],
      "Prekär": [
        "Kostenlose Backup-Lösung wählen",
        "Einfach einrichten",
        "Regelmäßige Backups aktivieren",
        "Wichtige Daten sichern",
        "Kostenlos nutzen",
        "Praktisch verwalten"
      ],
      "Konsum‑Hedonistisch": [
        "Benutzerfreundliche Backup-Lösung wählen",
        "Schnell einrichten",
        "Automatische Backups aktivieren",
        "Alle Daten sichern",
        "Sofort wirksam",
        "Modern verwalten"
      ]
    },
    "Automatische Updates": {
      "Traditionell": [
        "Automatische Updates für Betriebssystem aktivieren",
        "Automatische Updates für Apps aktivieren",
        "Regelmäßig prüfen, ob Updates installiert wurden",
        "Bewährte Einstellungen nutzen",
        "Vorsichtig vorgehen",
        "Bei Problemen manuell prüfen"
      ],
      "Konservativ‑Gehoben": [
        "Automatische Updates für Betriebssystem aktivieren",
        "Automatische Updates für Apps aktivieren",
        "Systematisch überprüfen",
        "Seriöse Einstellungen nutzen",
        "Professionell verwalten",
        "Regelmäßig kontrollieren"
      ],
      "Performer": [
        "Automatische Updates aktivieren",
        "Für alle Apps aktivieren",
        "Automatisierung nutzen",
        "Effizient verwalten",
        "Zeitsparend einrichten",
        "Systematisch überwachen"
      ],
      "Expeditiv": [
        "Automatische Updates aktivieren",
        "Für alle Apps aktivieren",
        "Moderne Einstellungen nutzen",
        "Innovativ verwalten",
        "Experimentieren",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Automatische Updates aktivieren",
        "Für wichtige Apps aktivieren",
        "Praktische Einstellungen nutzen",
        "Einfach verwalten",
        "Bei Bedarf anpassen",
        "Überwachen"
      ],
      "Neo‑Ökologisch": [
        "Automatische Updates aktivieren",
        "Für alle Apps aktivieren",
        "Nachhaltige Einstellungen nutzen",
        "Verantwortungsvoll verwalten",
        "Langfristig schützen",
        "Nachhaltig überwachen"
      ],
      "Postmateriell": [
        "Automatische Updates aktivieren",
        "Für alle Apps aktivieren",
        "Fundierte Einstellungen nutzen",
        "Tief verwalten",
        "Bewährte Praxis anwenden",
        "Verantwortungsvoll überwachen"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Automatische Updates aktivieren",
        "Für wichtige Apps aktivieren",
        "Bewährte Einstellungen nutzen",
        "Einfach verwalten",
        "Überschaubar halten",
        "Regelmäßig prüfen"
      ],
      "Prekär": [
        "Automatische Updates aktivieren",
        "Für wichtige Apps aktivieren",
        "Kostenlose Einstellungen nutzen",
        "Einfach verwalten",
        "Kostenlos schützen",
        "Praktisch überwachen"
      ],
      "Konsum‑Hedonistisch": [
        "Automatische Updates aktivieren",
        "Für alle Apps aktivieren",
        "Schnell einrichten",
        "Modern verwalten",
        "Sofort wirksam",
        "Unterhaltsam nutzen"
      ]
    },
    "Email Account absichern": {
      "Traditionell": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes, einzigartiges Passwort wählen",
        "Schritt-für-Schritt Anleitung befolgen",
        "Backup-Codes sicher aufbewahren",
        "Regelmäßig prüfen",
        "Vorsichtig vorgehen"
      ],
      "Konservativ‑Gehoben": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes, einzigartiges Passwort wählen",
        "Systematisch einrichten",
        "Backup-Codes sicher verwahren",
        "Professionell verwalten",
        "Regelmäßig kontrollieren"
      ],
      "Performer": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Schnell einrichten",
        "Backup-Codes speichern",
        "Effizient verwalten",
        "Zeitsparend nutzen"
      ],
      "Expeditiv": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Moderne Methoden nutzen",
        "Backup-Codes aufbewahren",
        "Innovativ verwalten",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Einfach einrichten",
        "Backup-Codes aufbewahren",
        "Praktisch verwalten",
        "Bei Bedarf anpassen"
      ],
      "Neo‑Ökologisch": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Nachhaltig einrichten",
        "Backup-Codes sicher verwahren",
        "Verantwortungsvoll verwalten",
        "Langfristig schützen"
      ],
      "Postmateriell": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Fundiert einrichten",
        "Backup-Codes sicher aufbewahren",
        "Tief verwalten",
        "Bewährte Praxis anwenden"
      ],
      "Nostalgisch‑Bürgerlich": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Einfach einrichten",
        "Backup-Codes aufbewahren",
        "Überschaubar verwalten",
        "Bewährte Methode nutzen"
      ],
      "Prekär": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Kostenlos einrichten",
        "Backup-Codes aufbewahren",
        "Einfach verwalten",
        "Kostenlos schützen"
      ],
      "Konsum‑Hedonistisch": [
        "2FA für E-Mail-Konto aktivieren",
        "Starkes Passwort wählen",
        "Schnell einrichten",
        "Backup-Codes aufbewahren",
        "Modern verwalten",
        "Sofort wirksam"
      ]
    },
    "Ad-Blocker": {
      "Traditionell": [
        "Ad-Blocker wie uBlock Origin auswählen",
        "In Browser installieren",
        "Bewährte Einstellungen nutzen",
        "Regelmäßig prüfen",
        "Vorsichtig konfigurieren",
        "Bei Bedarf anpassen"
      ],
      "Konservativ‑Gehoben": [
        "Seriösen Ad-Blocker wählen",
        "In Browser installieren",
        "Professionelle Einstellungen nutzen",
        "Systematisch konfigurieren",
        "Regelmäßig überprüfen",
        "Seriös verwalten"
      ],
      "Performer": [
        "Ad-Blocker installieren",
        "Schnell einrichten",
        "Effiziente Einstellungen nutzen",
        "Automatisierung aktivieren",
        "Zeitsparend konfigurieren",
        "Effizient verwalten"
      ],
      "Expeditiv": [
        "Modernen Ad-Blocker wählen",
        "Innovativ installieren",
        "Neue Features nutzen",
        "Experimentieren",
        "Optimieren",
        "Modern verwalten"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Ad-Blocker installieren",
        "Einfach einrichten",
        "Praktische Einstellungen nutzen",
        "Bei Bedarf anpassen",
        "Überwachen",
        "Praktisch verwalten"
      ],
      "Neo‑Ökologisch": [
        "Nachhaltigen Ad-Blocker wählen",
        "Verantwortungsvoll installieren",
        "Nachhaltige Einstellungen nutzen",
        "Langfristig konfigurieren",
        "Verantwortungsvoll verwalten",
        "Nachhaltig nutzen"
      ],
      "Postmateriell": [
        "Fundierten Ad-Blocker wählen",
        "Tief installieren",
        "Fundierte Einstellungen nutzen",
        "Verantwortungsvoll konfigurieren",
        "Bewährte Praxis anwenden",
        "Tief verwalten"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Bewährten Ad-Blocker wählen",
        "Einfach installieren",
        "Bewährte Einstellungen nutzen",
        "Überschaubar konfigurieren",
        "Klassisch verwalten",
        "Einfach nutzen"
      ],
      "Prekär": [
        "Kostenlosen Ad-Blocker wählen",
        "Einfach installieren",
        "Kostenlose Einstellungen nutzen",
        "Praktisch konfigurieren",
        "Kostenlos verwalten",
        "Einfach nutzen"
      ],
      "Konsum‑Hedonistisch": [
        "Benutzerfreundlichen Ad-Blocker wählen",
        "Schnell installieren",
        "Moderne Einstellungen nutzen",
        "Sofort wirksam",
        "Modern verwalten",
        "Spaß beim Nutzen"
      ]
    },
    "Router Passwort ändern": {
      "Traditionell": [
        "Router-Einstellungen öffnen",
        "Standard-Passwort finden",
        "Neues starkes Passwort wählen",
        "Passwort ändern",
        "WPA3-Verschlüsselung aktivieren (wenn verfügbar)",
        "Bewährte Methode anwenden"
      ],
      "Konservativ‑Gehoben": [
        "Router-Einstellungen öffnen",
        "Standard-Passwort identifizieren",
        "Starkes Passwort wählen",
        "Systematisch ändern",
        "WPA3-Verschlüsselung aktivieren",
        "Professionell absichern"
      ],
      "Performer": [
        "Router-Einstellungen öffnen",
        "Passwort schnell ändern",
        "Starkes Passwort wählen",
        "WPA3 aktivieren",
        "Effizient absichern",
        "Zeitsparend umsetzen"
      ],
      "Expeditiv": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Moderne Verschlüsselung nutzen",
        "WPA3 aktivieren",
        "Innovativ absichern",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Starkes Passwort wählen",
        "WPA3 aktivieren (wenn möglich)",
        "Praktisch absichern",
        "Einfach umsetzen"
      ],
      "Neo‑Ökologisch": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Starkes Passwort wählen",
        "WPA3-Verschlüsselung aktivieren",
        "Nachhaltig absichern",
        "Langfristig schützen"
      ],
      "Postmateriell": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Starkes Passwort wählen",
        "WPA3-Verschlüsselung aktivieren",
        "Fundiert absichern",
        "Verantwortungsvoll schützen"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Starkes Passwort wählen",
        "WPA3 aktivieren (wenn möglich)",
        "Bewährte Methode nutzen",
        "Einfach absichern"
      ],
      "Prekär": [
        "Router-Einstellungen öffnen",
        "Passwort ändern",
        "Starkes Passwort wählen",
        "WPA3 aktivieren (wenn möglich)",
        "Kostenlos absichern",
        "Einfach umsetzen"
      ],
      "Konsum‑Hedonistisch": [
        "Router-Einstellungen öffnen",
        "Passwort schnell ändern",
        "Starkes Passwort wählen",
        "WPA3 aktivieren",
        "Sofort wirksam",
        "Modern absichern"
      ]
    },
    "Social Media": {
      "Traditionell": [
        "Privatsphäre-Einstellungen auf allen Plattformen öffnen",
        "Einstellungen vorsichtig durchgehen",
        "Datenfreigabe minimieren",
        "Öffentliche Profile einschränken",
        "Bewährte Methoden anwenden",
        "Regelmäßig prüfen"
      ],
      "Konservativ‑Gehoben": [
        "Privatsphäre-Einstellungen auf allen Plattformen öffnen",
        "Systematisch durchgehen",
        "Datenfreigabe minimieren",
        "Reputation schützen",
        "Professionell konfigurieren",
        "Regelmäßig kontrollieren"
      ],
      "Performer": [
        "Privatsphäre-Einstellungen öffnen",
        "Schnell durchgehen",
        "Datenfreigabe minimieren",
        "Effizient konfigurieren",
        "Zeitsparend umsetzen",
        "Systematisch verwalten"
      ],
      "Expeditiv": [
        "Privatsphäre-Einstellungen öffnen",
        "Moderne Einstellungen nutzen",
        "Datenfreigabe minimieren",
        "Innovativ konfigurieren",
        "Experimentieren",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "Privatsphäre-Einstellungen öffnen",
        "Einfach durchgehen",
        "Datenfreigabe minimieren",
        "Praktisch konfigurieren",
        "Bei Bedarf anpassen",
        "Überwachen"
      ],
      "Neo‑Ökologisch": [
        "Privatsphäre-Einstellungen öffnen",
        "Verantwortungsvoll durchgehen",
        "Datenfreigabe minimieren",
        "Nachhaltig konfigurieren",
        "Verantwortungsvoll verwalten",
        "Langfristig schützen"
      ],
      "Postmateriell": [
        "Privatsphäre-Einstellungen öffnen",
        "Tief durchgehen",
        "Datenfreigabe minimieren",
        "Fundiert konfigurieren",
        "Bewährte Praxis anwenden",
        "Verantwortungsvoll verwalten"
      ],
      "Nostalgisch‑Bürgerlich": [
        "Privatsphäre-Einstellungen öffnen",
        "Einfach durchgehen",
        "Datenfreigabe minimieren",
        "Bewährte Einstellungen nutzen",
        "Überschaubar konfigurieren",
        "Klassisch verwalten"
      ],
      "Prekär": [
        "Privatsphäre-Einstellungen öffnen",
        "Einfach durchgehen",
        "Datenfreigabe minimieren",
        "Kostenlos konfigurieren",
        "Praktisch verwalten",
        "Einfach nutzen"
      ],
      "Konsum‑Hedonistisch": [
        "Privatsphäre-Einstellungen öffnen",
        "Schnell durchgehen",
        "Datenfreigabe minimieren",
        "Modern konfigurieren",
        "Sofort wirksam",
        "Unterhaltsam nutzen"
      ]
    },
    "App-Berechtigungen": {
      "Traditionell": [
        "App-Berechtigungen auf Smartphone öffnen",
        "Jede App einzeln prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Vorsichtig vorgehen",
        "Regelmäßig überprüfen",
        "Bewährte Methoden anwenden"
      ],
      "Konservativ‑Gehoben": [
        "App-Berechtigungen öffnen",
        "Systematisch prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Professionell verwalten",
        "Regelmäßig kontrollieren",
        "Seriös konfigurieren"
      ],
      "Performer": [
        "App-Berechtigungen öffnen",
        "Schnell prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Effizient verwalten",
        "Automatisierung nutzen",
        "Zeitsparend umsetzen"
      ],
      "Expeditiv": [
        "App-Berechtigungen öffnen",
        "Moderne Einstellungen nutzen",
        "Nur notwendige Berechtigungen gewähren",
        "Innovativ verwalten",
        "Experimentieren",
        "Optimieren"
      ],
      "Adaptiv‑Pragmatische Mitte": [
        "App-Berechtigungen öffnen",
        "Einfach prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Praktisch verwalten",
        "Bei Bedarf anpassen",
        "Überwachen"
      ],
      "Neo‑Ökologisch": [
        "App-Berechtigungen öffnen",
        "Verantwortungsvoll prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Nachhaltig verwalten",
        "Verantwortungsvoll konfigurieren",
        "Langfristig schützen"
      ],
      "Postmateriell": [
        "App-Berechtigungen öffnen",
        "Tief prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Fundiert verwalten",
        "Bewährte Praxis anwenden",
        "Verantwortungsvoll konfigurieren"
      ],
      "Nostalgisch‑Bürgerlich": [
        "App-Berechtigungen öffnen",
        "Einfach prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Bewährte Methode nutzen",
        "Überschaubar verwalten",
        "Klassisch konfigurieren"
      ],
      "Prekär": [
        "App-Berechtigungen öffnen",
        "Einfach prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Kostenlos verwalten",
        "Praktisch konfigurieren",
        "Einfach nutzen"
      ],
      "Konsum‑Hedonistisch": [
        "App-Berechtigungen öffnen",
        "Schnell prüfen",
        "Nur notwendige Berechtigungen gewähren",
        "Modern verwalten",
        "Sofort wirksam",
        "Unterhaltsam nutzen"
      ]
    }
  };
  
  // Funktion zum Abrufen der milieuspezifischen Checkliste
  export const getModuleChecklist = (moduleName, milieuName) => {
    if (!moduleName || !milieuName) {
      return null;
    }
    
    const checklists = MODULE_CHECKLISTS[moduleName];
    if (!checklists) {
      return null;
    }
    
    return checklists[milieuName] || null;
  };
  
  // Fallback-Checkliste, wenn keine milieuspezifische Checkliste gefunden wird
  export const getDefaultChecklist = (moduleName) => {
    const checklists = MODULE_CHECKLISTS[moduleName];
    if (checklists) {
      return Object.values(checklists)[0] || null;
    }
    return null;
  };
  
  